import { atom } from 'recoil';

const navigationAtom = atom({
  key: 'navigationAtom',
  default: {}
});

export default navigationAtom;